import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { changeLang } from "../NewWirebit/Settings/Components/utils";

const LanguageSelector = ({ traductions }) => {
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("lan") === "es"
      ? traductions.settings.services.L_langS
      : traductions.settings.services.L_langE
  );

  const handleClickToChange = () => {
    if (currentLang === "English") {
      changeLang("es", setCurrentLang, traductions);
    } else {
      changeLang("en", setCurrentLang, traductions);
    }
  };

  return (
    <button className="navbar_language_button" onClick={handleClickToChange}>
      <Image
        src={require("../../Images/language.svg")}
        className="navbar_icon_language"
        alt="language icon"
      />
      <p className="navbar_language_button_text">
        {currentLang === "English" ? "EN" : "ESP"}
      </p>
    </button>
  );
};

export default LanguageSelector;
